module.exports = __webpack_public_path__ + "static/media/logo-sensa.b044a853.svg";